<template>
  <div>
    <blog-block-form 
        
        :is-block-modal-active.sync="isBlockModalActive"
        :content-data="contentData"
        @refesh-block="getBlocks"
       
        />
    <blog-section-form
      :is-section-modal-active.sync="isSectionModalActive"
      :section-data="sectionData"
      @refesh-section="getSections"
    />
    <b-card title="Description">
      <draggable
        v-model="BlogInputContent"
        @change="ChangeSectionOrder(BlogInputContent)"
        :options="{ handle: '.handle' }"
      >
        <div
          :id="'content-' + item.id"
          :key="'content-' + index"
          v-for="(item, index) in even(BlogInputContent)"
          class="border mb-2 p-2"
        >
          <section v-if="item.remove !== true">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <feather-icon
                  icon="MenuIcon"
                  size="18"
                  class="cursor-pointer handle mr-2"
                />
                <span>{{ item.title[currentLocale] }}</span>
              </div>
              <div>
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  @click="deleteItem(item.id)"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </div>
            </div>
            <hr />
            <block-repeater
              v-if="item.id && renderComponent"
              :item-data="item"
              @update-block="updateBlock"
              @refesh-block="getBlocks"
            />
            <div>
              <div>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="addBlock(item)"
                >
                  <feather-icon icon="PlusIcon" /> Block
                </b-button>
              </div>
              <b-row> </b-row>
            </div>
          </section>
        </div>
      </draggable>
      <b-row>
        <b-col md="12" class="text-right">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="repeateAgain"
          >
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span> Description</span>
          </b-button></b-col
        >
        <b-col md="2"></b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
// Basic
import {
  BCard,
  BCardText,
  BFormFile,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import { ref } from "@vue/composition-api";


//Customize
import BlockRepeater from "./BlockRepeater.vue";
import BlogSectionForm from "./BlogSectionForm.vue";
import BlogBlockForm from './BlogBlockForm.vue';
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import draggable from "vuedraggable";


export default {
  components: {
    BCard,
    BCardText,
    BFormFile,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BImg,
    vSelect,
    BlogSectionForm,
    draggable,
    FeatherIcon,
    BlockRepeater,
    BlogBlockForm
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "BlogInputContent",
    prop: "BlogInputContentRemove",
    event: "update:blog-input-content",
    event: "update::blog-input-content-remove",
  },
  props: {
    BlogInputContent: {
      type: Array,
      required: true,
    },
    BlogInputContentRemove: {
      type: Array,
      required: true,
    },

    blogData: {
      type: Object,
      required: false,
    },
  },
  computed: {
       
       currentLocale() {
         return  this.$i18n.locale;
       },
   },

  setup(props, { emit }) {
    const isSectionModalActive = ref(false);
    const isBlockModalActive = ref(false);
    const contentData = ref({});
    const renderComponent = ref(true);
    const sectionData = ref({});
    const nextTodoId = ref(props.BlogInputContent.length + 1);

    const repeateAgain = () => {
      sectionData.value = {
        id: "",
        blog_id: props.blogData.id,
        title: {},
      };
      isSectionModalActive.value = true;
    };

    const addBlock = (item)=>{
        const blankData = {
            id:'',
            types:'content',
            title:{},
            blog_id: props.blogData.id,
            content_id:item.id,
            content:{},
            image:'',
            col:12
        };

        contentData.value = blankData;
      
        isBlockModalActive.value = true;
      }
      const updateBlock = (item)=>{
      
        contentData.value = item;
      
        isBlockModalActive.value = true;
      }

    const removeItem = async (id) => {
      let ind = props.BlogInputContent.findIndex((p) => p.id == id);
      if (id) {
        await store.dispatch("blog-section/deleteSection", id);
      }
      props.BlogInputContent.splice(ind, 1);
      emit("refesh-list");
    };
    const ChangeSectionOrder = async (items) => {
      // console.log("items-order", items);

      let params = {
        items: items,
      };

      let res = await store.dispatch("blog-section/UpdateOrder", params);
      if (res.data.success) {
        emit("refesh-list");
        props.BlogInputContent = items.map((item, indx) => {
          item.ordering_count = indx;
          return item;
        });
      }
    };

    const getBlocks = async (section_id) => {

      renderComponent.value = false;

      let ind = props.BlogInputContent.findIndex((p) => p.id == section_id);
      let blockes = await store.dispatch("blog-block/fetchData", section_id);
      props.BlogInputContent[ind].blocks = [];
      if (blockes.data.success) {
        props.BlogInputContent[ind].blocks = blockes.data.data;
      }
      emit('refesh-list');

      renderComponent.value = true;
      //console.log("PROP ", props.BlogInputContent[ind].block)
    };
    const getSections = async (itm) => {
      emit("refesh-list");

      let ind = props.BlogInputContent.findIndex((p) => p.id == itm.id);
      if (ind > -1) {
        props.BlogInputContent[ind].title = itm.title;
      } else {
        itm.block = [];
        props.BlogInputContent.push(itm);
      }
    };

    return {
      isSectionModalActive,
      repeateAgain,
      removeItem,
      contentData,
      addBlock,
      updateBlock,
      getBlocks,
      renderComponent,
      getSections,
      sectionData,
      ChangeSectionOrder,
      nextTodoId,
      isBlockModalActive,
      BlogBlockForm
    };
  },
  methods: {
    even: function (arr) {
      // Set slice() to avoid to generate an infinite loop!
      return arr.slice().sort(function (a, b) {
        return a.ordering_count - b.ordering_count;
      });
    },
    deleteItem(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete Blog Position." + id,
          {
            title: "Please Confirm",
            size: "sm",
            okVariant: "danger",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.removeItem(id);
          }

          //this.deleteData(id)
        });
    },

    /* initTrHeight() {
        this.trSetHeight(null)
        this.$nextTick(() => {
         // this.trSetHeight(this.$refs.form.scrollHeight)
        })
      },*/
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
</style>
